/**
 * Helper function to get the correct cookie domain
 * @returns {string} The domain string to use for cookies
 */
const getCookieDomain = () => {
  const { hostname } = window.location;

  // For production jiffy.com domains, use .jiffy.com to share across subdomains
  if (hostname.includes("jiffy.com")) {
    return "; domain=.jiffy.com";
  }

  // For staging or other environments, use the appropriate domain
  if (hostname.includes("jiffyshirts.com")) {
    return "; domain=.jiffyshirts.com";
  }

  // For local development or other domains, don't set domain attribute
  return "";
};

export const readCookie = name => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return decodeURIComponent(parts.pop().split(";").shift());
  return undefined;
};

/* eslint-disable max-params */
/*
 * @function writeCookie
 * @description Write a cookie with proper domain handling
 * @param {string} key - The key of the cookie
 * @param {string} value - The value of the cookie
 * @param {number} age - The number of seconds the cookie should last. max-age=3600 - 1 hour
 * @param {boolean} skipDomain - Optional flag to skip domain setting (default: false)
 */
export const writeCookie = (key, value, age = 3600, skipDomain = false) => {
  const domain = skipDomain ? "" : getCookieDomain();
  document.cookie = `${key}=${value}; max-age=${age}; path=/${domain}`;
};
/* eslint-enable max-params */

export const writePersistentCookie = (key, value, skipDomain = false) => {
  const expirationDate = new Date();
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);
  const domain = skipDomain ? "" : getCookieDomain();
  document.cookie = `${key}=${value}; expires=${expirationDate.toUTCString()}; path=/${domain}`;
};

export const checkOnePageCookie = cookieName => {
  const currentLocation = window.location.href;
  const { executed = false, initialLocation = currentLocation } = JSON.parse(
    readCookie(cookieName) || "{}"
  );

  // If the user has already dismissed the popup/tooltip/modal, don't show it again on other pages
  if (initialLocation !== currentLocation) {
    writeCookie(cookieName, JSON.stringify({ executed: true }));
    return true;
  }

  if (!executed) {
    writeCookie(cookieName, JSON.stringify({ initialLocation: currentLocation }));
  }

  return executed;
};

export const deleteCookie = key => {
  // Delete cookie for both with and without domain to ensure complete removal
  const domain = getCookieDomain();

  // Delete with domain
  document.cookie = `${key}=; max-age=-1; path=/${domain}`;

  // Also delete without domain (in case it was set that way)
  document.cookie = `${key}=; max-age=-1; path=/`;

  // Also try to delete for the specific subdomain (www.jiffy.com)
  if (window.location.hostname === "www.jiffy.com") {
    document.cookie = `${key}=; max-age=-1; path=/; domain=www.jiffy.com`;
  }
};

export default {};
